import { useEffect, useState } from 'react';
import { artUrl } from '../api/client';
import { hashHue, initials } from '../lib/format';

interface Props {
  /** « album/123 » */
  art?: string;
  name: string;
  size?: number;
  round?: boolean;
  className?: string;
  eager?: boolean;
}

/**
 * Pochette / portrait. Si aucune image n'existe (ni sur le serveur ni dans
 * la base d'enrichissement), on dessine un motif propre au nom.
 */
export function Cover({ art, name, size = 300, round, className = '', eager }: Props) {
  const [failed, setFailed] = useState(false);
  const src = art ? artUrl(art, size) : undefined;
  // Nouvelle image (pochette changée dans l'onglet Édition) : on réessaie
  useEffect(() => setFailed(false), [src]);
  const url = !failed ? src : undefined;
  const hue = hashHue(name);
  return (
    <div className={`cover ${round ? 'cover--round' : ''} ${className}`} style={{ ['--h' as string]: hue }}>
      {url ? (
        <img src={url} alt="" loading={eager ? 'eager' : 'lazy'} decoding="async" onError={() => setFailed(true)} draggable={false} />
      ) : (
        <span className="cover__ph" aria-hidden>
          {initials(name)}
        </span>
      )}
    </div>
  );
}
